export default "__VITE_ASSET__a928e812__"